import UpdateUserPage from "./UpdateUserPage";

export default UpdateUserPage;
